import React, { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

// Helpers
import { sanitizeFullName } from 'Shared/helpers';
import * as ReviewsHelpers from 'Shared/model_helpers/Reviews.helper';
import * as UserHelpers from 'Shared/model_helpers/User.helpers';

// Actions
import * as reviewActions from 'Shared/actions/Reviews.actions';

// Selectors
import * as ReviewsSelectors from 'Shared/selectors/Reviews.selectors';
import * as UserSelectors from 'Shared/selectors/Users.selectors';

// Components
import WpIcon from 'Wpds/components/icon/WpIcon';
import WpButton from 'Wpds/components/button/WpButton';

import './ReviewDropdown.scss';

type Props = {
  reviewSlug: string;
  clickViewDetails: Function;
};

function ReviewDropdown({ reviewSlug, clickViewDetails }: Props) {
  const dispatch = useDispatch();

  const handleViewDetailsOnClick = useCallback(() => {
    clickViewDetails();
  }, [clickViewDetails]);

  const review = useSelector(state => ReviewsSelectors.getReviewBySlug(state, { reviewSlug }));
  const receiverSlug = ReviewsHelpers.getReceiverSlug(review);
  const receiver = useSelector(state => UserSelectors.getUserByUserSlug(state, { userSlug: receiverSlug }));
  const receiverFirstName = UserHelpers.getFirstName(receiver);

  useEffect(() => {
    if (!review) dispatch(reviewActions.fetchReview({ reviewSlug }));
  }, [review]);

  const baseClassName = 'ReviewDropdown';
  const reviewOwner = receiverFirstName;
  return (
    <div className={`${baseClassName} d-flex flex-column`}>
      <div className={`${baseClassName}__header d-flex justify-content-between align-items-center p-2`}>
        <div className="d-flex align-items-center flex-nowrap">
          <WpIcon name="atom-alt" />
          <div className="ml-1">Review</div>
        </div>
        <div className={`${baseClassName}__header_owner`}>Receiver: {sanitizeFullName(reviewOwner)}</div>
      </div>
      <div className={`${baseClassName}__content px-2`}>
        <div className={`${baseClassName}__content__actions`}>
          <WpButton onClick={handleViewDetailsOnClick}>View Details</WpButton>
        </div>
      </div>
    </div>
  );
}

export default ReviewDropdown;
